import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RcsCampaignStatsHeader } from '@/components/rcs/RcsCampaignStatsHeader';
import { RcsCampaignActions } from '@/components/rcs/RcsCampaignActions';
import { RcsCampaignDispatchesTable } from '@/components/rcs/RcsCampaignDispatchesTable';
import { useRcsCampaignDetail } from '@/hooks/useRcs';

function RcsCampaignDetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-8 w-64" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-lg" />
        ))}
      </div>
      <Skeleton className="h-48 rounded-lg" />
    </div>
  );
}

export function RcsCampaignDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading } = useRcsCampaignDetail(id ?? '');

  return (
    <div className="space-y-6">
      <Button variant="ghost" size="sm" className="-ml-2" onClick={() => navigate('/rcs')}>
        <ArrowLeft className="h-4 w-4" />
        RCS
      </Button>

      {isLoading ? (
        <RcsCampaignDetailSkeleton />
      ) : data ? (
        <>
          <RcsCampaignStatsHeader campaign={data.campaign} stats={data.stats} />

          <RcsCampaignActions campaign={data.campaign} />

          <Card>
            <CardHeader>
              <CardTitle className="text-base">Disparos</CardTitle>
            </CardHeader>
            <CardContent>
              <RcsCampaignDispatchesTable campaignId={data.campaign.id} />
            </CardContent>
          </Card>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Campanha não encontrada.</p>
      )}
    </div>
  );
}
